<template>
  <div>
    <div class="containar">
      <div class="contents-block">
        <div class="preview-area">
          <div class="preview-header">
            <h3>プレビュー</h3>
          </div>
          <ul class="flex-containar-2">
            <li class="voice-state-2">
              <img class="img-2 color1" v-bind:style="{outlineColor: colors.hex8,boxShadow: '4px 4px 0px 0 ' + colors.hex8}" :src="imgPath">
              <div class="name-box-2">
                <span class="name-2" v-bind:style="{background: colors.hex8}" >User1</span>
              </div>
            </li>
            <li class="voice-state-2">
              <img class="img-2 color2" v-bind:style="{outlineColor: colors.hex8,boxShadow: '4px 4px 0px 0 ' + colors.hex8}" :src="imgPath">
              <div class="name-box-2">
                <span class="name-2" v-bind:style="{background: colors.hex8}">User2</span>
              </div>
            </li>
            <li class="voice-state-2">
              <img class="img-2 color3" v-bind:style="{outlineColor: colors.hex8,boxShadow: '4px 4px 0px 0 ' + colors.hex8}" :src="imgPath">
              <div class="name-box-2">
                <span class="name-2" v-bind:style="{background: colors.hex8}">User3</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="set">
          <h3>名前のカラー選択</h3>
          <div class="color-picker-wrapper">
            <chrome-picker :value="colors" v-model="colors"></chrome-picker>
          </div>
          
          <h3>コピペ用CSS</h3>
          <div class="url-description">
            <p>DiscordオーバレイのカスタムCSSです。</p>
            <p><a href="https://streamkit.discord.com/overlay" target="_blank" rel="noopener noreferrer">streamkit</a>でDiscordのボイスチャンネルのURLを取得→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
            <p><a href="https://www.ruri.info/?p=188" target="_blank" rel="noopener noreferrer">さらに詳しい使い方はこちら</a></p>
          </div>
          <div class="url-container">
            <textarea id="target" readonly class="url-input textarea" v-model="resultCSS" />
            <button @click="copy" class="url-copy-btn">
              <span>コピー</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Chrome} from 'vue-color'
export default {
  name: "app",
  components: {
    'chrome-picker': Chrome,
   },
  data() {
    return {
      imgPath: require('@/assets/discord-icon.png'),
      colors: {
          hex: '#000000',
          hex8: '#000000FF',
          hsl: { h: 150, s: 0, l: 0, a: 1 },
          rgba: { r: 0, g: 0, b: 0, a: 1 },
          a: 1
      },
      importcss:':root {\n',
      namecolor:'--name-bg-color:',
    };
  },
  methods: {
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText("[class*='Voice_voiceStates__']{list-style-type:none;padding-left:15px;display:flex;flex-wrap:wrap;}[class*='Voice_voiceState__']{height:96px;}[class*='Voice_avatar__']{width:96px;height:96px;border-radius:12px;filter:brightness(90%);transition:filter 0.2s ease;margin-top:18px;margin-right: 18px;margin-bottom:3px;outline:0.13rem solid var(--name-bg-color)!important;border:none;box-shadow:4px 4px 0px 0 var(--name-bg-color);}[class*='Voice_avatarSpeaking__']{animation:var(--speaking-anime);filter:brightness(100%)!important;border:none!important;}[class*='Voice_name__']{text-align:center;width:96px;background-color:var(--name-bg-color)!important;opacity:var(--name-opacity)!important;font-size:12px!important;border-radius:6px;padding:1px 0px!important;margin-right:2px;margin-left:2px;margin-top:105px;box-sizing:border-box;overflow:hidden;display:block;}ul li{margin-top:30px;display:block;}[class*='Voice_name__']{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}\n" +this.importcss + this.namecolor + this.colors.hex8 + ";}\n")
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
  },
  watch:{
    namestyle:function(){
        this.setNameCss()
    },
  },
  computed: {
    resultCSS(){
        return "[class*='Voice_voiceStates__']{list-style-type:none;padding-left:15px;display:flex;flex-wrap:wrap;}[class*='Voice_voiceState__']{height:96px;}[class*='Voice_avatar__']{width:96px;height:96px;border-radius:12px;filter:brightness(90%);transition:filter 0.2s ease;margin-top:18px;margin-right: 18px;margin-bottom:3px;outline:0.13rem solid var(--name-bg-color)!important;border:none;box-shadow:4px 4px 0px 0 var(--name-bg-color);}[class*='Voice_avatarSpeaking__']{animation:var(--speaking-anime);filter:brightness(100%)!important;border:none!important;}[class*='Voice_name__']{text-align:center;width:96px;background-color:var(--name-bg-color)!important;opacity:var(--name-opacity)!important;font-size:12px!important;border-radius:6px;padding:1px 0px!important;margin-right:2px;margin-left:2px;margin-top:105px;box-sizing:border-box;overflow:hidden;display:block;}ul li{margin-top:30px;display:block;}[class*='Voice_name__']{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}\n" +this.importcss + this.namecolor + this.colors.hex8 + ";}\n";
    },
  },
};
</script>
<style scoped>
p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

h3{
  font-size: 14px;
  margin-top: 24px;
  margin-bottom: 0;
}

.containar{
  margin: 0 auto;
  width: 100%;
}

/* Layout Styles */
.contents-block{
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	-webkit-justify-content: space-around;
	justify-content: space-around;
	-webkit-align-items: flex-start;
	align-items: flex-start;
  margin: 24px auto;
  gap: 24px;
}

@media screen and (max-width: 767px) {
  .contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
    margin-left: 0;
  }
}

.set{
  flex: 1;
  max-width: 420px;
  padding: 8px 12px 24px 12px;
  background-color: #FFFEF9;
  border-radius: 10px;
}

/* プレビューエリア */
.preview-area{
  flex: 1;
  max-width: 420px;
  min-width: 320px;
}

.preview-header{
  padding: 2px 12px;
  margin-bottom: 16px;
}

.flex-containar-2{
    height: 120px;
    width:100%;
    display: flex;
}

.voice-state-2{
    list-style-type: none;
    padding-left: 15px;
    display: block;
    margin-bottom: 8px;
}

.img-2{
    width: 96px;
    height: 96px;
    border-radius: 12px;
    object-fit: scale-down;
    padding: 5px;
    box-sizing:border-box;

    outline: 0.13rem solid;
    box-shadow: 4px 4px 0px 0 black;
}

.color1{
  background-color: blue;
}

.color2{
  background-color: lightcoral;
}

.color3{
  background-color: lightgreen;
}

.name-box-2{
    margin: 8px 0 0 0;
    color:white;
    width:96px;
    display: block;
    text-align: center;
}

.name-2{
    padding: 4px 12px;
    color:white;
    font-size:12px;
    border-radius: 6px;
    display: block;
    margin: 0 4px 0 4px;
}






/* Color Picker */
.color-picker-wrapper {
  margin-top: 12px;
}

.color-picker-wrapper .vc-chrome {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px #e2e8f0;
  font-family: system-ui, -apple-system, sans-serif;
}

.color-picker-wrapper .vc-saturation-wrap {
  border-radius: 6px 6px 0 0;
}

.color-picker-wrapper .vc-chrome-controls {
  padding: 12px;
}

.color-picker-wrapper .vc-hue,
.color-picker-wrapper .vc-alpha {
  border-radius: 4px;
  height: 12px;
}

.color-picker-wrapper .vc-chrome-fields-wrap {
  padding-top: 12px;
}

.color-picker-wrapper .vc-input__input {
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 12px;
}

.color-picker-wrapper .vc-input__input:focus {
  border-color: #0f172a;
  outline: none;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.2);
}

.color-picker-wrapper .vc-input__label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.color-picker-wrapper .vc-chrome-color-wrap {
  border-radius: 4px;
}

.color-picker-wrapper .vc-chrome-active-color {
  border-radius: 4px;
}

.color-picker-wrapper .vc-hue-pointer,
.color-picker-wrapper .vc-alpha-pointer {
  width: 16px;
  height: 16px;
}

.color-picker-wrapper .vc-hue-picker,
.color-picker-wrapper .vc-alpha-picker {
  background: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.color-picker-wrapper .vc-saturation-pointer {
  width: 14px;
  height: 14px;
}

.color-picker-wrapper .vc-saturation-circle {
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* URL Section */
.url-description {
  margin: 12px 0 16px 0;
}

.url-description p {
  font-size: 13px;
  color: #718096;
  margin: 0 0 6px 0;
  line-height: 1.5;
}

.url-description a {
  color: #0f172a;
  text-decoration: underline;
}

.url-description a:hover {
  color: #1e293b;
}

.url-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
  margin-bottom: 16px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 12px;
  background: #f8fafc;
  color: #4a5568;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  line-height: 1.4;
  resize: vertical;
}

.url-input.textarea {
  height: 80px;
  padding: 12px;
  resize: vertical;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
}

.url-copy-btn {
  padding: 0 20px;
  height: 2.4em;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-copy-btn:hover {
  background: #0f172a;
  transform: translateY(-1px);
}

.url-copy-btn:active {
  transform: translateY(0);
}

</style>